import { Button, TextField } from '@mui/material'
import React from 'react'

function QuoteSign() {
return (
    <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', gap: 32, minHeight: '80vh' }}>
        <div style={{ background: '#f5f5f5', borderRadius: 8, padding: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {/* Remplacez ceci par votre composant PDF ou un <iframe> pour afficher le PDF */}
            <div style={{ width: '100%', height: '70vh', background: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span>PDF à afficher ici</span>
            </div>
        </div>
        <form style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 400, margin: 'auto' }}>
            <TextField label="Nom" name="lastName" variant="outlined" required />
            <TextField label="Prénom" name="firstName" variant="outlined" required />
            <TextField
                label="Signature"
                name="signature"
                variant="outlined"
                required
                placeholder="Saisissez votre nom en guise de signature"
            />
            <Button type="submit" variant="contained" color="primary">
                Soumettre
            </Button>
        </form>
    </div>
)
}

export default QuoteSign